import 'bootstrap.collapse';
import 'bootstrap.dropdown';
import 'configure-default-runtime';
import 'global';
import { onLoad } from 'runtime';
import '/assets/theme/js/mmenu-light.js?v=2';

// Add class sticky to menu on scroll.
const header = document.getElementById('header');

let lastScrollY = window.scrollY;

window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
    const scrollingDown = currentScrollY > lastScrollY;

    // Toggle sticky styles based on scroll position
    if (currentScrollY > 300) {
        header.classList.add('sticky-styles');
    } else {
        header.classList.remove('sticky-styles');
    }

    // Show/hide based on scroll direction
    if (scrollingDown && currentScrollY > 700) {
        header.classList.add('is-hidden');
        header.classList.remove('is-visible');
    } else {
        header.classList.remove('is-hidden');
        header.classList.add('is-visible');
    }

    lastScrollY = currentScrollY;
});

// Mobile Menu
const menu = new MmenuLight(document.querySelector('#menu-navbar'), '(max-width: 991px)');

menu.navigation({
    slidingSubmenus: true,
    title: 'Menu'
});

const drawer = menu.offcanvas({
    position: 'left'
});

// Open the menu.
document.querySelector('button[href="#menu-navbar"]')
    .addEventListener('click', e => {
        e.preventDefault();
        drawer.open();
    });

onLoad(context => {
    // Scroll reveal styles
    scrollRevealOnScroll(context, '.scroll-reveal, .result, .box, .accreditations, .key-point, .product', 'fade-in-up');
    scrollRevealOnScroll(context, '.scroll-reveal-scale, .contact-footer', 'fade-in-scale');
    scrollRevealOnScroll(context, '.scroll-reveal-left, .tabs, .feature-item', 'fade-in-left');
    scrollRevealOnScroll(context, '.scroll-reveal-right, .question, .key-item', 'fade-in-right');

    // Scroll To
    context.querySelectorAll('.scroll-to').forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            var href = link.getAttribute('href'); // Use 'link' instead of 'this'.
            var target = context.querySelector(href);

            // Calculate the offsetTop including the offset of all parent elements.
            var offsetTop = target.offsetTop;
            var currentElement = target;
            while (currentElement.offsetParent !== null) {
                currentElement = currentElement.offsetParent;
                offsetTop += currentElement.offsetTop;
            }
            window.scroll({
                top: offsetTop - 120,
                behavior: 'smooth'
            });
        });
    });
});

function scrollRevealOnScroll(context, revealSelector, animationClass) {
    var elements = context.querySelectorAll(revealSelector);

    if (elements.length === 0) return;

    function revealElements() {
        elements.forEach(function(element) {
            // Skip if already revealed
            if (element.classList.contains(animationClass)) return;

            var rect = element.getBoundingClientRect();
            var positionFromTop = rect.top;

            if (positionFromTop <= window.innerHeight && rect.bottom >= 0) {
                element.classList.add(animationClass);
            }
        });
    }

    // Reveal anything already visible shortly after load
    window.addEventListener('load', function() {
        setTimeout(revealElements, 100); // slight delay for smoother effect
    });

    // Reveal on scroll
    window.addEventListener('scroll', revealElements);
}